import React from 'react'
import { motion } from 'framer-motion'

interface GlassCardProps {
  children: React.ReactNode
  className?: string
  hover?: boolean
  blur?: 'sm' | 'md' | 'lg'
  opacity?: number
  onClick?: () => void
  /** Default brand panel card; use glass for dark surfaces */
  variant?: 'panel' | 'glass'
  /** When false, skip the inner padding wrapper */
  padded?: boolean
}

const GlassCard: React.FC<GlassCardProps> = ({
  children,
  className = '',
  hover = true,
  blur = 'md',
  onClick,
  variant = 'panel',
  padded = true,
}) => {
  const blurClasses = {
    sm: 'backdrop-blur-sm',
    md: 'backdrop-blur-md',
    lg: 'backdrop-blur-lg',
  }

  const surface =
    variant === 'glass'
      ? `rounded-3xl border border-white/15 bg-white/10 ${blurClasses[blur]} shadow-soft backdrop-saturate-150 ${
          hover ? 'hover:bg-white/15 hover:border-white/25' : ''
        }`
      : `panel-card ${hover ? 'hover:shadow-soft-lg hover:-translate-y-1' : ''} transition-all duration-300`

  return (
    <motion.div
      className={`relative ${surface} ${className}`}
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.45 }}
      whileHover={
        hover
          ? {
              y: -4,
              transition: { duration: 0.2 },
            }
          : {}
      }
      onClick={onClick}
    >
      <div className={`relative z-10 ${padded ? 'panel-card-body' : ''}`}>
        {children}
      </div>
    </motion.div>
  )
}

export default GlassCard
